<template>
  <header class="header">
    <nuxt-link to="/" class="logo">
      <Logo viewBox="0 0 421 77" />
    </nuxt-link>
  </header>
</template>

<script>
import Logo from '../assets/svg/calculators-logo-extended.svg?vue-component';

export default {
  components: {
    Logo,
  },
};
</script>

<style scoped lang="scss">
.header {
  position: sticky;
  top: 0;
  z-index: 4;
  height: 77px;
  display: flex;
  align-items: center;
  background-image: url('../assets/images/home-v3-bg.webp');
  background-color: var(--main-light-shade-1);

  .logo {
    height: 100%;

    > svg {
      max-width: 100%;
      height: inherit;
    }
  }
}
</style>
